import { BRAND_DISPLAY_NAME } from '@streamlain/brand';
import { z } from 'zod';

export const appSchemes = z.enum([
  'streamlain',
  'streamlain-canary',
  'streamlain-beta',
  'streamlain-internal',
  'streamlain-dev',
]);

export type Scheme = z.infer<typeof appSchemes>;
export type Channel = 'stable' | 'canary' | 'beta' | 'dev' | 'internal';

export const schemeToChannel = {
  streamlain: 'stable',
  'streamlain-canary': 'canary',
  'streamlain-beta': 'beta',
  'streamlain-internal': 'internal',
  'streamlain-dev': 'dev',
} as Record<Scheme, Channel>;

export const channelToScheme = {
  stable: 'streamlain',
  canary: BUILD_CONFIG.debug ? 'streamlain-dev' : 'streamlain-canary',
  beta: 'streamlain-beta',
  dev: 'streamlain-dev',
  internal: 'streamlain-internal',
} as Record<Channel, Scheme>;

export const appIconMap = {
  stable: '/imgs/app-icon-streamlain.svg',
  canary: '/imgs/app-icon-streamlain.svg',
  beta: '/imgs/app-icon-streamlain.svg',
  dev: '/imgs/app-icon-streamlain.svg',
  internal: '/imgs/app-icon-streamlain.svg',
} satisfies Record<Channel, string>;

export const appNames = {
  stable: BRAND_DISPLAY_NAME,
  canary: BRAND_DISPLAY_NAME,
  beta: BRAND_DISPLAY_NAME,
  dev: BRAND_DISPLAY_NAME,
  internal: BRAND_DISPLAY_NAME,
} satisfies Record<Channel, string>;

export const appSchemaUrl = z.custom<string>(
  url => {
    if (typeof url !== 'string') return false;
    try {
      return appSchemes.safeParse(new URL(url).protocol.replace(':', ''))
        .success;
    } catch {
      return false;
    }
  },
  { message: 'Invalid URL or protocol' }
);
